<template>
  <div>
    <div class="sidebar" :class="{ active: sideBarOpen }">
      <div class="sidebarInner">
        <div class="sidebarInnerLocations">
          <div
            class="sidebarLocation"
            v-for="location of updatedSidebarLocations"
            v-bind:key="location.name"
            :id="`sidebarLocation-${location.id}`"
            :data-index="location.id"
            :data-lat="location.position.lat"
            :data-lng="location.position.lng"
            :data-filter="
              location.category
                .split(' ')
                .join('')
                .replace(',', '_')
            "
          >
            <div class="sidebarContent">
              <div class="sideImages">
                <div class="sideImage">
                  <img :src="require(`@/assets/pics/${location.image}`)" alt="" />
                </div>
                <div class="cornerShadow"></div>
                <div class="closeSidebar"></div>
              </div>
              <div class="sidebarContentCopy">
                <div class="sideAddress">{{ location.location }}</div>
                <div class="sideName">{{ location.name }}</div>
                <div
                  class="sideDescription"
                  v-html="loadSidebarDescription(location.description)"
                ></div>
                <a class="sideCta" :href="location.cta" rel="nofollow sponsored" target="_blank">
                  Discover more
                </a>
              </div>
            </div>
            <div class="sidebarNav">
              <div class="chevron left firstclass"></div>
              <div class="sideIndex">
                {{ updatedSidebarLocations.indexOf(location) + 1 }}
                of {{ updatedSidebarLocations.length }}
              </div>
              <div class="chevron right ${lastClass}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import marked from 'marked';
import analytics from '@/helpers/analytics';

export default {
  name: 'Sidebar',
  data() {
    return {
      isSideBarOpen: false,
      categoryList: this.$store.state.categoryList,
    };
  },
  mounted() {},
  methods: {
    imgSrc(imgName) {
      const imgSrc = this.$store.state.imagesExternalPath + imgName.trim();
      return imgSrc;
    },
    loadSidebarCategoryLabel(category) {
      const splitCategory = category.split(',');
      const catFilters = ['retirement', 'housing', 'sme', 'future', 'urban', 'climate'];
      let cathtml = '';
      splitCategory.forEach((e) => {
        const catFiltersIndex = catFilters.indexOf(e.replace(' ', ''));
        cathtml += `<div class="sidebarCategory ${e}">
          ${this.$store.state.categoryList[catFiltersIndex].text}
        </div>`;
      });
      return cathtml;
    },
    loadSidebarDescription(description) {
      const rawDesc = description.replace(/\n/g, '\n\n');
      const deschtml = marked(rawDesc);
      return deschtml;
    },
    setIcon(iconName, size) {
      const icon = {
        url: `/pins/${iconName}.svg`,
        scaledSize: { width: size, height: size },
        labelOrigin: { x: 0, y: 0 },
      };
      return icon;
    },
  },
  updated() {
    const sidebarLocation = document.querySelectorAll('.sidebarLocation');
    const hideSlides = () => {
      sidebarLocation.forEach((e) => {
        e.style.display = 'none';
      });
    };

    const panToMarker = (lat, lng) => {
      const marker = {
        lat: Number(lat),
        lng: Number(lng),
      };
      this.$store.state.mainMap.panTo(marker);
    };

    const closeBtn = document.querySelectorAll('.closeSidebar');
    closeBtn.forEach((e) => {
      e.addEventListener('click', () => {
        this.$store.commit('closeSidebar');
        this.$store.commit('filterToggled', false);
        this.$store.state.mainMap.panTo(this.$store.state.centerTo);
        this.$store.commit('updateZoomLevel', this.$store.state.resetZoom);
        document.querySelector('.resetMap').style.display = 'none';
      });
    });

    const nextSlide = document.querySelectorAll('.chevron.right');
    nextSlide.forEach((e) => {
      e.addEventListener('click', () => {
        const toTheRightSlide = e.closest('.sidebarLocation').nextSibling;
        if (toTheRightSlide != null) {
          const dataLat = document.getElementById(`${toTheRightSlide.id}`).dataset.lat;
          const dataLng = document.getElementById(`${toTheRightSlide.id}`).dataset.lng;
          const updateSelectedPin = document.getElementById(`${toTheRightSlide.id}`).dataset.index;
          this.$store.commit('updateSelectedPin', updateSelectedPin);
          hideSlides();
          document.getElementById(`${toTheRightSlide.id}`).style.display = 'flex';
          panToMarker(dataLat, dataLng);
          analytics.send(`location ${updateSelectedPin} - selected (nav)`);
        }
      });
    });

    const prevSlide = document.querySelectorAll('.chevron.left');
    prevSlide.forEach((e) => {
      e.addEventListener('click', () => {
        const toTheLeftSlide = e.closest('.sidebarLocation').previousSibling;
        if (toTheLeftSlide != null) {
          const dataLat = document.getElementById(`${toTheLeftSlide.id}`).dataset.lat;
          const dataLng = document.getElementById(`${toTheLeftSlide.id}`).dataset.lng;
          const updateSelectedPin = document.getElementById(`${toTheLeftSlide.id}`).dataset.index;
          this.$store.commit('updateSelectedPin', updateSelectedPin);
          hideSlides();
          document.getElementById(`${toTheLeftSlide.id}`).style.display = 'flex';
          panToMarker(dataLat, dataLng);
          analytics.send(`location ${updateSelectedPin} - selected (nav)`);
        }
      });
    });
  },
  computed: {
    sideBarOpen() {
      return this.$store.state.sideBarOpen;
    },
    updatedSidebarLocations() {
      return this.$store.state.sidebarLocations;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: absolute;
  display: block;
  width: 100%;
  max-width: 340px;
  height: 100vh;
  z-index: 3;
  background: #fff;
  opacity: 1;
  left: -100%;
  top: 0px;
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  @media only screen and (max-width: 767px) {
    max-width: 100%;
  }

  &.active {
    left: 0px;
    z-index: 6;
  }

  .sidebarInner {
    position: relative;
    height: 100%;
    // overflow: scroll;

    .sidebarInnerLocations {
      position: relative;
    }
  }
  .nextPrev {
    width: 100%;
    bottom: 20px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.tLocbutton {
  position: absolute;
  top: 0;
  z-index: 100;
  background-color: #fff;
  color: red;
  font-weight: 700;
}
</style>

<style lang="scss">
// .sidebarInnerLocations {}
.sidebarLocation {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100vh;

  .closeSidebar {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
  .closeSidebar:hover {
    opacity: 0.75;
  }
  .closeSidebar:before,
  .closeSidebar:after {
    content: '';
    position: absolute;
    left: 0px;
    height: 20px;
    width: 2px;
    background-color: #fff;
  }
  .closeSidebar:before {
    transform: rotate(45deg);
  }
  .closeSidebar:after {
    transform: rotate(-45deg);
  }

  .sidebarContent {
    overflow-y: scroll;

    .sideImages {
      display: block;
      position: relative;
      overflow: hidden;

      .sideImage {
        display: block;
        object-fit: cover;
        width: 100%;
        position: relative;

        img {
          display: block;
          width: 100%;
        }
      }
      .cornerShadow {
        background: radial-gradient(circle, rgba(2, 0, 36, 0.4) 0%, rgba(255, 255, 255, 0) 60%);
        width: 100px;
        height: 100px;
        position: absolute;
        top: -40px;
        right: -40px;
      }
    }
    .sidebarContentCopy {
      margin: 20px 20px 100px 20px;

      .sideAddress {
        font: bold 12px/18px 'Roboto';
        letter-spacing: 0px;
        color: #1d1d1d;
      }
      .sideFilter {
        font: normal 12px/18px 'Roboto';
        letter-spacing: 0px;
        color: #333;

        .sidebarCategory {
          position: relative;
        }
        .sidebarCategory:before {
          content: '';
          margin: 4px 0 0 -20px;
          position: absolute;
          width: 4px;
          height: 10px;
          display: none; /* display: block; */
        }
        .sidebarCategory.retirement:before {
          background-color: var(--retirement);
        }
        .sidebarCategory.housing:before {
          background-color: var(--housing);
        }
        .sidebarCategory.sme:before {
          background-color: var(--sme);
        }
        .sidebarCategory.future:before {
          background-color: var(--future);
        }
        .sidebarCategory.urban:before {
          background-color: var(--urban);
        }
        .sidebarCategory.climate:before {
          background-color: var(--climate);
        }
      }
      .sideName {
        font: normal 24px/29px 'LyonBold';
        margin: 20px 0;
      }
      .sideDescription {
        margin: 0 0 30px 0;
        font: normal 12px/18px 'Roboto';
      }
      .sideCta {
        cursor: pointer;
        width: 125px;
        height: 42px;
        font: normal 12px/42px 'Roboto';
        text-decoration: none;
        letter-spacing: 0px;
        color: #fff;
        background: #008844 0% 0% no-repeat padding-box;
        border-radius: 2px;
        display: block;
        text-align: center;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .sidebarNav {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding-top: 20px;
    position: absolute;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 57%, rgba(255, 255, 255, 0) 85%);
    bottom: 0;

    .sideIndex {
      text-align: center;
      margin: 20px;
      width: 100%;
      font: 500 12px/18px 'Roboto';
    }
  }

  .chevron {
    cursor: pointer;
  }
  .chevron::before {
    border-style: solid;
    border-width: 0.1px 0.1px 0 0;
    content: '';
    display: inline-block;
    height: 0.45em;
    left: 0.15em;
    position: relative;
    top: 0.45em;
    transform: rotate(-45deg);
    vertical-align: top;
    width: 0.45em;
  }
  .chevron.right.last,
  .chevron.left.first {
    color: #ccc;
    cursor: initial;
  }
  .chevron.right:before {
    left: 100%;
    margin-left: -33px;
    transform: rotate(45deg);
  }
  .chevron.left:before {
    left: 20px;
    transform: rotate(-135deg);
  }
}
</style>
